import React from "react";

interface TokenErrorProps {
  expired: boolean;
  onReset: () => void;
  onBackToSignIn: () => void;
  loading: boolean;
  error: string | null;
}

export default function TokenError({
  expired,
  onReset,
  onBackToSignIn,
  loading,
  error,
}: TokenErrorProps) {
  return (
    <div className="text-center">
      <div className="mb-4">
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke={expired ? "#f59e0b" : "#dc3545"}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      </div>

      {expired ? (
        <>
          <h1 className="h3 fw-bold text-dark mb-1">This invite has expired</h1>
          <p className="text-muted mb-4">
            Don&apos;t worry — you can reset your password to access your
            account.
          </p>

          {error && (
            <div className="alert alert-danger py-2 mb-3" role="alert">
              {error}
            </div>
          )}

          <button
            type="button"
            className="btn btn-primary btn-lg w-100 mb-3"
            onClick={onReset}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                />
                Sending...
              </>
            ) : (
              "Reset Password"
            )}
          </button>
        </>
      ) : (
        <>
          <h1 className="h3 fw-bold text-dark mb-1">This link is invalid</h1>
          <p className="text-muted mb-4">
            This link may have already been used or is not recognized.
          </p>
        </>
      )}

      <button
        type="button"
        className="btn btn-outline-primary btn-lg w-100"
        onClick={onBackToSignIn}
      >
        Back to sign in
      </button>
    </div>
  );
}
